<template>
  <svg class="icon icon-search-mobile" xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17">
    <path
      d="M16.872,16.28,11.36,10.76a6.489,6.489,0,1,0-.6.6l5.522,5.518a.414.414,0,0,0,.585.006l.006-.006a.417.417,0,0,0,.005-.589ZM6.5,12.126A5.625,5.625,0,1,1,12.123,6.5h0A5.629,5.629,0,0,1,6.5,12.125Z" />
  </svg>
</template>

<script>
export default {
  name: 'IconSearchMobile'
}
</script>
